import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DemoProvider, useDemo } from "@/store/DemoContext";
import { AppNav } from "@/components/AppNav";
import { DemoPanel } from "@/components/DemoPanel";
import { Toaster } from "@/components/ui/sonner";
import { Onboarding } from "@/screens/Onboarding";
import Home from "@/screens/Home";
import LineupBuilder from "@/screens/LineupBuilder";
import ComparisonView from "@/screens/ComparisonView";
import ResultScreen from "@/screens/ResultScreen";
import SeasonView from "@/screens/SeasonView";
import Leaderboard from "@/screens/Leaderboard";
import Profile from "@/screens/Profile";

function Shell() {
  const { i18n } = useTranslation();
  const { state, profile } = useDemo();

  useEffect(() => {
    if (i18n.language !== state.language) i18n.changeLanguage(state.language);
  }, [state.language, i18n]);

  const showOnboarding = profile.profileType === "new" && !state.onboardingSeen;

  return (
    <div className="App min-h-screen grain">
      <AppNav />
      <main className="relative z-[2]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/build/:fixtureId" element={<LineupBuilder />} />
          <Route path="/compare/:fixtureId" element={<ComparisonView />} />
          <Route path="/result/:fixtureId" element={<ResultScreen />} />
          <Route path="/season" element={<SeasonView />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </main>
      <DemoPanel />
      {showOnboarding && <Onboarding />}
      <Toaster position="top-center" />
    </div>
  );
}

function App() {
  return (
    <DemoProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </DemoProvider>
  );
}

export default App;
